module.exports = __webpack_public_path__ + "static/media/chipa_blurry_light.3ca85e16.png";